import './card-member.scss';
import {
	ArcElement,
	BarController,
	BarElement,
	CategoryScale,
	Chart,
	DoughnutController,
	Legend,
	LineController,
	LineElement,
	LinearScale,
	PointElement,
	Title,
	Tooltip,
} from 'chart.js';

export default () => {
	Chart.register( DoughnutController,  LineController, LineElement, PointElement,  CategoryScale, LinearScale, BarController, BarElement, ArcElement, Tooltip, Legend, Title );

	const charts = document.querySelectorAll( '.gauge-chart' );

	charts.forEach( ( chart ) => {
		doughnutChart( chart, chart.dataset.color1, chart.dataset.color2 );
	} );

	function doughnutChart ( element, color1, color2 ) {
		new Chart( element, {
			type: 'doughnut',
			data: {
				labels: [
					'Red',
					'Blue',
					'Yellow',
				],
				datasets: [ {
					label: 'My Dataset',
					data: [
						element.dataset.value,
						element.dataset.max,
					],
					backgroundColor: [
						color1,
						color2,
					],
					borderWidth: 0,
					hoverOffset: 0,
				} ],
			},
			options: {
				responsive: true,
				cutout: '75%',
				plugins: {
					legend: {
						display: false,
					},
					display: false,
					title: {
						display: false,
						text: 'Doughnut Chart',
					},
					tooltip: {
						enabled: false,
					},
				},
				hover: {
					mode: null,
				},
			},
		} );
	}

	// Pie Chart
	const pieCharts = document.querySelectorAll( '.pie-chart' );

	pieCharts.forEach( ( chart ) => {
		pieChart( chart, chart.dataset.data, chart.dataset.color );
	} );

	function pieChart ( chart, data, colors ) {
		new Chart( chart, {
			type: 'doughnut',
			data: {
				labels: [
					'Red',
					'Blue',
					'Yellow',
					'black',
				],
				datasets: [ {
					label: 'My Dataset',
					data: JSON.parse( data ),
					backgroundColor: JSON.parse( colors ),
					hoverOffset: 4,
					borderWidth: 0,
				} ],
			},
			options: {
				responsive: true,
				cutout: '50%',
				plugins: {
					legend: {
						display: false,
					},
					display: false,
					title: {
						display: false,
						text: 'Doughnut Chart',
					},
					tooltip: {
						enabled: false,
					},
				},
				hover: {
					mode: null,
				},
			},
		} );
	}

	// Bar chart
	const barCharts = document.querySelectorAll( '.bar-chart' );

	barCharts.forEach( ( chart ) => {
		barChart( chart, chart.dataset.data, chart.dataset.color, chart.dataset.name );
	} );

	function barChart ( chart, data, colors, barName ) {
		new Chart( chart, {
			type: 'bar',
			data: {
				labels: [
					'<40',
					'40-49',
					'50-59',
					'60-69',
					'70+',
				],
				datasets: [ {
					label: 'Año 2018',
					data: JSON.parse( data ),
					backgroundColor: JSON.parse( colors ),
					borderWidth: 0,
					borderRadius: 6,
					borderColor: '#514cc4',
				} ],
			},
			options: {
				responsive: true,
				scales: {
					y: {
						type: 'linear',
						min: 1,
						max: 4,
						beginAtZero: true,
						ticks: {
							stepSize: 1,
							callback: function ( value ) {
								return `${value * 25}%`; // Since 5 = 100%, 1 = 20%
							},
						},
						title: {
							display: true,
							text: barName,
							font: {
								size: 12,
								weight: 'medium',
							},
							color: '#000',
						},
					},
					x: {
						title: {
							display: true,
							text: 'Age',
							font: {
								size: 12,
								weight: 'medium',
							},
							color: '#000',
						},
					},
				},
				plugins: {
					title: {
						display: false,
					},
					legend: {
						display: false,
					},
				},
			},
		} );
	}
};
